import React from 'react'
import StatsItem from '../Component/Stats/StatsItem'

const Statistics = () => {
  return (
    <div>
      <StatsItem />
    </div>
  )
}

export default Statistics
